import React from "react";
import {colorForDirection} from "../common/styles";

function toSentenceCase(text) {
    if (!text || text.length < 1) {
        return text;
    }
    return text && text.charAt(0).toUpperCase() + text.toLowerCase().slice(1);
}

const DirectionType = (props) => (
    <div className="x-direction" style={Object.assign({}, props.style || {}, {color: colorForDirection(props.direction)})}>{toSentenceCase(props.direction)}</div>
);
DirectionType.propTypes = {
    direction: React.PropTypes.string,
    style: React.PropTypes.object
};

export default DirectionType;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/DirectionType.js
 **/